import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { theme } from 'src/styles/theme';

import IconButton from '../../../Buttons/IconButton';
import CloseIcon from '../../../images/close.svg';
import useStyles from './styles';

const ModalHeader = ({ children, className, Icon, ariaLabelledBy, negative, onClose, showIcon }) => {
  const classes = useStyles({ negative });
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    <Grid className={cx(classes.header, className)} container direction="row" wrap="nowrap">
      <Grid alignItems="center" container direction="row" item wrap="nowrap" zeroMinWidth>
        {showIcon && (
          <Grid alignItems="center" className={classes.headerIcon} container item justify="center">
            {typeof Icon === 'function' ? (
              <Icon color={negative && theme.palette.error.main} />
            ) : (
              <img alt="" role="presentation" src={Icon} />
            )}
          </Grid>
        )}
        <Typography
          className={classes.title}
          color="textPrimary"
          display="inline"
          id={ariaLabelledBy}
          noWrap
          variant="subtitle2"
        >
          {children}
        </Typography>
      </Grid>
      <IconButton onClick={onClose}>
        <img alt="close-button" src={CloseIcon} />
      </IconButton>
    </Grid>
  );
};

ModalHeader.propTypes = {
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  ariaLabelledBy: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]), // must match ariaLabelledBy prop of modal
  className: PropTypes.string,
  negative: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  showIcon: PropTypes.bool,
};

ModalHeader.defaultProps = {
  showIcon: true,
};

export default ModalHeader;
